/**
 * @copyright       Palace Resorts
 * @description     Mensajes para el formulario de registro de un proveedor outsourcing
 * @author          
 * @creationDate    
 */
 export default {
    fallbackLocale: 'ESP',
    locale: 'ESP',
    messages: {
        'ESP': {
            lblGeneralData: "Datos Generales",
            lblSTPSRegister: "Registro STPS",
            lblEmployerRegister: "Registro Patronal",
            lblOutsourcingActivities: "Actividades de subcontratación",
            lblDocuments: "Documentos",
            lblDocument: "Documento",
            lblID: "ID",
            lblFolio: "Folio",
            lblPostalCode: "Código postal",
            lblMatrix: "Matriz",
            lblTotalWorkers: "Total trabajadores",
            lblDescripcion: "Descripción",
            lblDateStart: "Fecha de vigencia inicio",
            lblDateEnd: "Fecha de vigencia fin",
            lblCheck: "Activar check si se desea cambiar el archivo",
            lblFile: "Archivo",
            
        },
        'ENG': {
            lblGeneralData: "General Data",
            lblSTPSRegister: "STPS Register",
            lblEmployerRegister: "Employer Register",
            lblOutsourcingActivities: "Outsourcing Activities",
            lblDocuments: "Documents",
            lblDocument: "Document",
            lblID: "ID",
            lblFolio: "Folio",
            lblPostalCode: "Postal code",
            lblMatrix: "Matrix",
            lblTotalWorkers: "Total workers",
            lblDescripcion: "Description",
            lblDateStart: "Date start",
            lblDateEnd: "Date end",
            lblCheck: "Activate check if you want to change the file",
            lblFile: "File", 
        }
    } //end Messages
}